import {Component, ViewChild} from '@angular/core';
import {NavParams, ViewController, Content, Tab, App} from 'ionic-angular';
import {CONFIG} from "../../../app/config";
import {TAction, TPrivacyFlag} from "../../../app/enum";
import {TGoogleAnalytic, Util} from "../../../app/util";
import {WebsiteSpotPage} from "../website-spot/website-spot";
import {HotspotService} from "../../../providers/hotspot-service";
import {LogadoService} from "../../../providers/logado-service";
import {ProfileService} from "../../../providers/profile-service";
import {HotspotRepository} from "../../../repositories/hotspot-repository";
import {PushRepository} from "../../../repositories/push-repository";

import {PrivacyMenuPage} from "../privacy-menu/privacy-menu";
import {PaybookFindPage} from "../paybook-find/paybook-find";

@Component({
    selector: 'page-hotspot-love',
    templateUrl: 'hotspot-love.html',
    providers: [HotspotService, HotspotRepository, ProfileService, PushRepository]
})
export class HotspotLovePage {

    TPrivacyFlag: any = TPrivacyFlag;

    config: any;
    etapa: number = 0;

    extraSelf: boolean;

    logado: any;
    rootile: any;

    hotspots: any;
    hotloved: any;

    @ViewChild(Content) content: Content;

    constructor(public navParams: NavParams, public viewCtrl: ViewController, public app: App, public util: Util,
                public logadoService: LogadoService,
                public profileService: ProfileService,
                public hotspotService: HotspotService, public hotspotRepository: HotspotRepository,
                public pushRepository: PushRepository) {

        this.config = CONFIG;

        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.rootile = this.navParams.get('rootile');

        this.extraSelf = (this.logado.Profile.ProfileID == this.rootile.Profile.ProfileID);


        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Checkin Spot', '/checkin-spot');
        this.hotspotLove();

        this.pushRepository.badgeDel(['seguidor']).subscribe();

    }

    ionViewDidLoad() {

    }

    getTitle() {

        return 'Lugares';

    }

    hotspotLove() {

        if (!this.logado.Profile.PrivacySpot && !this.extraSelf) return;

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.hotspot(TAction.acGoin, 0, this.rootile.Profile.ProfileID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    this.hotspots = data.Hotspots;
                    this.hotloved = data.Hotspots.find(HS => HS.HotspotLove);
                    this.hotspotRepository.subscribeFolloweChanged(this.hotspots).subscribe();
                },
                erro => this.util.alertResult(erro)
            );

    }

    hotspotPage(hotspotID, branded) {

        let activeTab: Tab = this.app.getRootNavs()[0].getActiveChildNavs()[0].getActiveChildNavs()[0];

        let object = {hotspotID: hotspotID, brandex: branded, tabmenu: true};
        activeTab.push(WebsiteSpotPage, object);

    }

    paybookFind(hotspot) {

        let hotspotID = (hotspot ? hotspot.HotspotID : 0);
        let object = {etapa: 1, userset: null, hotspotID: hotspotID, geradorID: 0, profile: this.rootile.Profile, profileID: this.rootile.Profile.ProfileID};
        this.util.modalopen(PaybookFindPage, 'alto', false, object).subscribe();

    }

    followeBell(event, hotspot: any) {

        let profileID = this.rootile.Profile.ProfileID;
        this.hotspotRepository.followe(event, hotspot, profileID).subscribe(data => {}, erro => {});

    }

    privacyMenu() {

        let onReload = () => {

            this.hotspotLove();
            this.profileService.profile(TAction.acLoad, this.rootile.Profile.ProfileID)
                .subscribe(data => this.util.clearObj(this.rootile, [], data));

        };

        let copy = this.util.deepCopy(this.logado);

        let object = {etapa: 4, rootile: this.logado, copyile: copy};
        this.util.modalopen(PrivacyMenuPage, 'quad', true, object).subscribe(data => {

            if (data.privacyEdit) onReload();

        });

    }

    dismiss(success?: boolean) {

        this.viewCtrl.dismiss({success: success});

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/hotspot-love/hotspot-love.ts